/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { axiosInstance } from '../axiosInstance'


export const getOnlineOfflineStatus = param => {
    return axiosInstance.post(`/api/gcadmin/v1/network/get-online-offline-status`, param).then(res => res.data)
}
export const networkSync = param => {
    return axiosInstance.post(`/api/gcadmin/v1/network/sync`, param).then(res => res.data)
}
export const updateOnlineOfflineStatus = param => {
    return axiosInstance.post(`/api/gcadmin/v1/network/update-online-offline-status`, param).then(res => res.data)
}